import { render, staticRenderFns } from "./requestPrice.vue?vue&type=template&id=237a7410&"
import script from "./requestPrice.vue?vue&type=script&lang=js&"
export * from "./requestPrice.vue?vue&type=script&lang=js&"
import style0 from "./requestPrice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports